<template>
  <div id="app" class="1.0.1">
    <router-view />
  </div>
</template>

<script>
import "@/assets/scss/main.scss"
export default {
  name: 'App',
  watch: {
    '$i18n.locale': function(newVal) {
      this.handleLocaleChange(newVal)
    }
  },
  mounted() {
    console.log('APP_VERSION', process.env.APP_VERSION)
    this.handleLocaleChange(this.$i18n.locale)
  },
  methods: {
    handleLocaleChange(newVal) {
      if (newVal === 'zh') {
        document.querySelector('html').setAttribute('lang', 'zh-Hant')
      } 
      
      if(newVal === 'en') {
        document.querySelector('html').setAttribute('lang', 'en')
      }

      if(newVal === 'vi') {
        document.querySelector('html').setAttribute('lang', 'vi')
      }
    }
  }
}
</script>

